import { AnimationPlayer, NoopAnimationPlayer } from '@angular/animations';
import { AnimationDriver, NoopAnimationDriver } from '@angular/animations/browser';
import { ANIMATION_MODULE_TYPE, Injectable, Provider } from '@angular/core';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';

/**
 * NoopAnimationsModule still builds animation players. Material overlays (select, menu,
 * datepicker, dialog, tooltip) and sidenav then read `parentPlayer.startTime` while CD
 * is in flight, which throws. This driver returns players that always have a startTime
 * but still finish on play() so OverlayRef onDone/detach subscriptions are not missed.
 */
@Injectable()
export class SafeNoopAnimationDriver extends NoopAnimationDriver {
  override animate(
    element: unknown,
    _keyframes: Array<Map<string, string | number>>,
    duration: number,
    delay: number,
    _easing?: string | null,
    _previousPlayers?: unknown[]
  ): AnimationPlayer {
    const player = new NoopAnimationPlayer(duration, delay) as NoopAnimationPlayer & {
      startTime: number;
      parentPlayer: AnimationPlayer;
      element?: unknown;
    };
    player.startTime = 0;
    player.parentPlayer = player;
    player.element = element;
    return player;
  }
}

/** App-wide: skip Material JS animations and keep overlay/sidenav players from throwing. */
export const SAFE_NOOP_ANIMATION_PROVIDERS: Provider[] = [
  { provide: ANIMATION_MODULE_TYPE, useValue: 'NoopAnimations' },
  { provide: AnimationDriver, useClass: SafeNoopAnimationDriver },
  { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
];
